export const APP_CONFIG = {

  app: 'Corpay',
  appName: 'Corpay WebApp',
  user: 'Waleed & Mohammad',
  email: 'wlaid.mukahal@progressoft.com',
  twitter: 'waleed8855',
  avatar: 'avatar-admin.png',
  version: '4.0.0',
  bs4v: '4.3',
  logo: 'logo.png',
  logoM: 'logo.png',
  // tslint:disable-next-line:max-line-length
  copyright: 'Copyrights © 2019. All rights reserved',
  // tslint:disable-next-line:max-line-length
  // copyrightInverse: '2019 © SmartAdmin by&nbsp;<a href="https://www.gotbootstrap.com" class="text-white opacity-40 fw-500" title="gotbootstrap.com" target="_blank">gotbootstrap.com</a>'
};
